<div class="sidebar" [class.collapsed]="!sidebarService.isExpanded()" [class.mobile]="sidebarService.isMobile()">
  <!-- Mobile Overlay -->
  <div *ngIf="sidebarService.isMobile() && sidebarService.isExpanded()" class="sidebar-overlay"
    (click)="closeSidebar()"></div>

  <div class="sidebar-content">
    <nav class="sidebar-nav">
      <div class="nav-section">
        <h3 class="nav-section-title" [class.hidden]="!sidebarService.isExpanded()">
          RISK MANAGEMENT
        </h3>
        <ul class="nav-list">
          <!-- <li class="nav-item">
            <a  class="nav-link" [ngClass]="{'active': isActive('/dashboard')}"
              data-tooltip="Dashboard" (click)="navigateTo('/dashboard')">
              <img
                [src]="isActive('/dashboard') ? 'assets/images/icons/dashboard-active-icon.svg' : 'assets/images/icons/dashboard-icon.svg'"
                alt="Dashboard Icon" class="nav-icon" />
              <span [class.hidden]="!sidebarService.isExpanded()">Dashboard</span>
            </a>
          </li> -->
          <li class="nav-item">
            <a  class="nav-link"
              [ngClass]="{'active': isActive('/workbench')}" (click)="navigateTo('/workbench')"
              data-tooltip="Workbench">
              <img
                [src]="isActive('/workbench') ? 'assets/images/icons/workbench-active-icon.svg' : 'assets/images/icons/workbench-icon.svg'"
                alt="Workbench Icon" class="nav-icon" />
              <span [class.hidden]="!sidebarService.isExpanded()">Workbench</span>
            </a>
          </li>
        </ul>
      </div>

      <!-- <div class="nav-section">
        <h3
          class="nav-section-title"
          [class.hidden]="!sidebarService.isExpanded()"
        >
          SETTINGS
        </h3>
        <ul class="nav-list">
          <li class="nav-item">
            <a
              routerLink="/settings"
              routerLinkActive="active"
              class="nav-link"
            >
              <img src="assets/images/icons/settings-icon.svg"
                alt="Settings Icon"
                class="nav-icon" />
              <span [class.hidden]="!sidebarService.isExpanded()"
                >Settings</span
              >
            </a>
          </li>
          <li class="nav-item">
            <a
              routerLink="/settings/profile"
              routerLinkActive="active"
              class="nav-link"

            >
              <img src="assets/images/icons/profile-icon.svg"
                alt="Profile Icon"
                class="nav-icon" />
              <span [class.hidden]="!sidebarService.isExpanded()"
                >My Profile</span
              >
            </a>
          </li>
        </ul>
      </div> -->
    </nav>

    <!-- Collapse Toggle Button -->
    <div class="sidebar-footer" *ngIf="!sidebarService.isMobile()">
      <ng-container *ngIf="sidebarService.isExpanded()">
        <!-- <button class="logout-btn" (click)="logout()" title="Logout">
          <img src="assets/images/icons/logout-icon.svg" alt="Logout Icon" class="logout-icon" />
          <span>Logout</span>
        </button> -->
      </ng-container>
      <button class="collapse-toggle" (click)="toggleSidebar()">
        <img [style.transform]="sidebarService.isExpanded() ? 'rotate(180deg)' : 'rotate(0deg)'"
          src="assets/images/icons/collapse-toggle-icon.svg" alt="Collapse Icon" class="collapse-icon" />
        <!-- <span [class.hidden]="!sidebarService.isExpanded()">Collapse</span> -->
      </button>
    </div>
  </div>
</div>
